import { render, staticRenderFns } from "./ReturnProductList.vue?vue&type=template&id=60c7e0e5&scoped=true&"
import script from "./ReturnProductList.vue?vue&type=script&lang=js&"
export * from "./ReturnProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c7e0e5",
  null
  
)

export default component.exports